import services from "services/offers";
import _ from "lodash";
import router from '../../../routes'

const state = {
  offers: [],
  sessions: [],
  selectedOffer: {},
  selectedSession: {},
  selectedCategory: {},
  categories: [],
  pagination: [],
  totalPages: "",
  currentPage: ""
};

const getters = {
  offers(state) {
    return state.offers;
  },
  sessions(state) {
    return state.sessions;
  },
  categories(state) {
    return state.categories;
  },
  totalPages(state) {
    return state.totalPages;
  },
  currentPage(state) {
    return state.currentPage;
  },
  pagination(state) {
    const { total, limit, skip } = state.pagination;
    return _.extend(state.pagination, {
      pages: Math.ceil(total / limit),
      current: Math.ceil((skip - 1) / limit) + 1
    });
  },
  selectedOffer(state) {
    return state.selectedOffer;
  },
  selectedSession(state) {
    return state.selectedSession;
  },
  selectedCategory(state) {
    return state.selectedCategory;
  }
};

const actions = {
  async fetchOffers({ commit }, query) {
    const payload = (await services.offers(query)).data;
    commit("fetchOffers", payload);
  },
  async fetchSessions({ commit }, query) {
    const payload = (await services.sessions(query)).data;
    commit("fetchSessions", payload);
  },
  async selectOffer({ commit }, id) {
    const payload = (await services.showOffer(id)).data;
    commit("selectOffer", await payload);
  },
  async selectAdminOffer({ commit }, id) {
    const payload = (await services.adminOffer(id)).data;
    commit("selectOffer", await payload);
  },
  async selectCategory({ commit }, id) {
    const payload = (await services.offerCategory(id)).data;
    commit("selectCategory", payload);
  },
  selectOfferCategory: ({ commit }, category) => {
    commit("selectOfferCategory", category);
  },
  newOffer: ({ commit }) => {
    commit("newOffer");
  },
  newCategory: ({ commit }) => {
    commit("newCategory");
  },
  resetSelected: ({ commit }) => {
    commit("resetSelected");
  },
  addOffer: ({ commit }, offer) => {
    services.addOffer(offer).then(payload => {
      commit("addOffer", payload.data);
      commit("selectOffer", payload.data);
      router.push({ name: 'edit-offer', params: { offerId: payload.data.id} })
    });
  },
  updateOffer: ({ commit }, offer) => {
    services.updateOffer(offer.id, offer).then(offer => {
      commit("updateOffer", offer.data);
    });
  },
  removeOffer: ({ commit }, offer) => {
    services.deleteOffer(offer.id, offer).then(offer => {
      commit("removeOffer", offer);
    });
  },
  restoreOffer: ({ commit }, offer) => {
    services.restoreOffer(offer.id, offer).then(offer => {
      commit("restoreOffer", offer);
    });
  },
  addCategory: ({ commit }, category) => {
    services.addCategory(category).then(category => {
      commit("addCategory", category);
    });
  },
  updateCategory: ({ commit }, category) => {
    services.updateCategory(category.id, category).then(category => {
      commit("updateCategory", category.data);
    });
  },
  deleteCategory: ({ commit }, category) => {
    services.deleteCategory(category.id, category).then(category => {
      commit("removeCategory", category);
    });
  },
  deleteCategoryTheme: ({ commit }, data) => {
    services.deleteCategoryTheme(data).then(category => {
      commit("updateCategory", category.data);
    });
  },
  async removeTheme({ commit }, data) {
    const payload = (await services.deleteTheme(data)).data;
  },
  addPrice: ({ commit }, offer) => {
    commit("addPrice", offer);
  },
  addSession: ({ commit }, offer) => {
    commit("addSession", offer);
  },
  selectSession: ({ commit }, session) => {
    commit("selectSession", session);
  },
  updateSession: ({ commit }, session) => {
    services.updateSession(session.id, session).then(offer => {
      commit("selectSession", {});
      commit("updateOffer", offer.data);
    });
  },
  addSessionPrice: ({ commit }, session) => {
    commit("addSessionPrice", session);
  },
  removeSession: ({ commit }, session) => {
    commit("removeSession", session);
    services.deleteSession(session.id, session).then(offer => {});
  },
  removeMedia: ({ commit }, media) => {
    services.deleteMedia(media.id, media).then(media => {});
  },
  fetchCategories: ({ commit }, query) => {
    return services.offerCategories(query).then(categories => {
      commit("fetchCategories", categories.data);
    });
  },
  fetchSessionCategories: ({ commit }, query) => {
    services.sessionCategories(query).then(categories => {
      commit("fetchCategories", categories.data);
    });
  }
};

const mutations = {
  fetchOffers: (state, offers) => {
    state.offers = offers.offers;
    state.pagination = offers.meta.pagination;
    state.totalPages = offers.meta.pagination.total_pages;
    state.currentPage = offers.meta.pagination.current_page;
  },
  fetchSessions: (state, offers) => {
    state.sessions = offers.sessions;
    state.pagination = offers.meta.pagination;
    state.totalPages = offers.meta.pagination.total_pages;
    state.currentPage = offers.meta.pagination.current_page;
  },
  selectOffer: (state, offer) => {
    state.selectedOffer = offer;
  },
  selectCategory: (state, category) => {
    state.selectedCategory = category;
  },
  selectOfferCategory: (state, category) => {
    state.selectedOffer.category = category;
  },
  selectSession: (state, session) => {
    state.selectedSession = session;
  },
  newOffer: state => {
    state.selectedOffer = {
      name: {
        fr: ""
      },
      description: {
        fr: ""
      },
      advantages: {
        fr: ""
      },
      condition: {
        fr: ""
      },
      themeId: null,
      categoryId: null,
      category: {},
      prices: [],
      sessions: []
    };
  },
  newCategory: state => {
    state.selectedCategory = {
      name: {
        fr: ""
      },
      themes: [],
      schooling_offers: 0,
      school_type: null,
      has_sessions: 0,
      has_date_limit: 0,
      has_free_sessions: 0,
      has_file_upload: 0,
      order: 0
    };
  },
  resetSelected: state => {
    state.selectedOffer = {};
  },
  addOffer: (state, offer) => {
    state.offers.unshift(offer);
    state.pagination.total++;
  },
  updateOffer: (state, offer) => {
    state.selectedOffer = offer;
    state.offers = [
      offer,
      ...state.offers.filter(element => element.id !== offer.id)
    ];
  },
  removeOffer: (state, offer) => {
    const index = _.findIndex(state.offers, { _id: offer._id });
    state.offers.splice(index, 1, offer);
  },
  restoreOffer: (state, offer) => {
    state.offers.push(offer);
  },
  addCategory: (state, category) => {
    state.categories.unshift(category);
  },
  updateCategory: (state, category) => {
    state.selectedCategory = category;
    state.categories = [
      category,
      ...state.categories.filter(element => element.id !== category.id)
    ];
  },
  removeCategory: (state, category) => {
    const index = _.findIndex(state.categories, { _id: category._id });
    state.categories.splice(index, 1, category);
  },
  addPrice: (state, offer) => {
    let price = {
      school_id: null,
      offer_id: offer.id,
      price: null,
      year: null
    };
    offer.prices.push(price);
  },
  addSession: (state, offer) => {
    let session = {
      campus_id: null,
      offer_id: offer.id,
      begin: null,
      end: null,
      total_places: null,
      new: true,
      prices: []
    };
    offer.sessions.unshift(session);
  },
  updateSession: (state, session) => {
    state.selectedSession = {};
    state.selectedOffer.sessions = [
      session,
      ...state.selectedOffer.sessions.filter(
        element => element.id !== session.id
      )
    ];
  },
  addSessionPrice: (state, session) => {
    let index = state.selectedOffer.sessions.indexOf(session);
    let price = {
      school_id: null,
      offer_id: session.offer_id,
      offer_session_id: session.id,
      price: null,
      year: null
    };
    state.selectedOffer.sessions[index].prices.push(price);
  },
  removeSession: (state, session) => {
    state.selectedOffer.sessions.splice(
      state.selectedOffer.sessions.indexOf(session),
      1
    );
  },
  fetchCategories: (state, categories) => {
    state.categories = categories;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
